import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import {
  colorBackgroundInfo,
  colorBorder,
  colorSlotConfirmed,
  colorSlotDeal,
  colorSlotEvent,
  colorSlotPending,
  colorTextMuted,
  radiusChip,
} from "src/design/tokens";

interface LegendItem {
  color: string;
  labelKey: string;
  /** Pale fills need an outline to read against the card background. */
  outlined?: boolean;
}

const LEGEND_ITEMS: LegendItem[] = [
  { color: colorSlotConfirmed, labelKey: "tableSchedule.legend.confirmed" },
  { color: colorSlotPending, labelKey: "tableSchedule.legend.pending" },
  {
    color: colorBackgroundInfo,
    labelKey: "tableSchedule.legend.open",
    outlined: true,
  },
  { color: colorSlotDeal, labelKey: "tableSchedule.legend.deal", outlined: true },
  {
    color: colorSlotEvent,
    labelKey: "tableSchedule.legend.event",
    outlined: true,
  },
];

interface BoardLegendProps {
  sx?: SxProps;
}

/** Colour key for the grid, sitting between the tray and the board itself. */
export const BoardLegend = ({ sx }: BoardLegendProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: { xs: 0.75, sm: 1.5 },
        rowGap: 0.25,
        flexShrink: 0,
        ...sx,
      }}
    >
      {LEGEND_ITEMS.map((item) => (
        <Box
          key={item.labelKey}
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              flexShrink: 0,
              borderRadius: radiusChip,
              backgroundColor: item.color,
              border: item.outlined ? `1px solid ${colorBorder}` : "none",
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: 11, sm: 12 },
              lineHeight: 1.4,
              color: colorTextMuted,
            }}
          >
            {t(item.labelKey)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
